<template>
    <div class="page" id="pro">
        <header class="pageHeader">
            <fade-image src="assets/headers/profile.png" />
        </header>

        <div id="scroller">
            <div class="pageHeaderIntro higher">
                <h1>
                    Hi <span class="capitalise">{{ user.first_name }}</span
                    >!
                </h1>
                <p data-cy="welcome">Welcome back to Lesson Pro</p>
                <img class="icon" src="~@/assets/icons/headers/profile.svg" />
            </div>

            <home-content-ad />

            <lesson-cancelled-notification
                @dismissed="cancelledLessons = false"
                :cancelledLessons="cancelledLessons"
                v-if="cancelledLessons && cancelledLessons.length > 0"
            />

            <h2 class="title" v-if="current_lesson">Current Lesson:</h2>
            <h2 class="title" v-else>Next Lesson:</h2>

            <next-lesson
                :lesson="next_lesson"
                :pro="true"
                :player="next_lesson.player"
                :current_lesson="current_lesson"
            />

            <h2 class="title">Tasks:</h2>

            <ul id="tasks" class="proHomeTasks">
                <li>
                    <router-link :to="{ name: 'proInvite', query: { from: 'home' } }">
                        <img
                            style="width: 24px"
                            src="@/assets/icons/home/profile-small-mid-green.svg"
                        />
                        Add player
                        <img class="plus" src="@/assets/plus-dark-green.svg" />
                    </router-link>
                </li>

                <li>
                    <router-link :to="{ name: 'proLessonBook', query: { from: 'home' } }">
                        <img src="@/assets/icons/home/lesson-light-green-small.svg" alt="" />
                        Book lesson
                        <img class="plus" src="@/assets/plus-white.svg" />
                    </router-link>
                </li>

                <li>
                    <router-link :to="{ name: 'proOffersNew', query: { from: 'home' } }">
                        <img
                            style="transform: translateY(-6px)"
                            src="@/assets/offer-correct.svg"
                            alt=""
                        />
                        Create offer
                        <img class="plus" src="@/assets/plus-white.svg" />
                    </router-link>
                </li>

                <li>
                    <router-link :to="{ name: 'proPlayerMessagesNew', query: { from: 'home' } }">
                        <img src="@/assets/icons/home/messages-small-light-green.svg" alt="" />
                        New message
                        <img class="plus" src="@/assets/plus-dark-green.svg" />
                    </router-link>
                </li>
            </ul>

            <h2 class="title">Profile:</h2>

            <ul id="tasks" class="proHomeTasks bottomTasks">
                <li class="bagLink">
                    <router-link :to="{ name: 'proBag' }">
                        What's in the bag:
                        <img class="arrow" src="@/assets/arrow-right-green.svg" />
                        <img class="bag" src="@/assets/bag.svg" />
                    </router-link>
                </li>

                <li class="bagLink2">
                    <router-link :to="{ name: 'proProfile' }">
                        Your profile:
                        <img class="arrow" src="@/assets/arrow-right-white-2.svg" />
                        <img class="prof" src="@/assets/profile.svg" />
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import LessonCancelledNotification from "@/components/Pro/lesson-cancelled-notification";
import NextLesson from "@/components/Pro/Next-lesson";
import FadeImage from "@/components/App/fade-image";
import HomeContentAd from "@/components/App/home-content-ad";
export default {
    name: "player-profile",
    components: {
        FadeImage,
        HomeContentAd,
        NextLesson,
        LessonCancelledNotification,
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        lessons() {
            return this.$store.state.proLessons;
        },
        current_lesson() {
            var date = new Date();
            var response = false;

            this.lessons.forEach((lesson) => {
                var $end = this.$date(lesson.date).format("YYYY-MM-DD") + " " + lesson.end;

                if (date >= this.$date(lesson.date) && date <= this.$date($end)) {
                    response = lesson;
                }
            });

            return response;
        },
        next_lesson() {
            if (this.current_lesson) {
                return this.current_lesson;
            }

            var date = new Date();
            var closest = Infinity;
            var response = false;

            this.lessons.forEach((lesson) => {
                if (this.$date(lesson.date) >= date && this.$date(lesson.date) < closest) {
                    closest = this.$date(lesson.date);
                    if (!lesson.cancelled_at) {
                        response = lesson;
                    }
                }
            });
            return response;
            //return this.$store.state.user.next_lesson
        },
    },
    data() {
        return {
            cancelledLessons: false,
        };
    },
    created() {
        this.$store.dispatch("getProLessons");
        this.getCancelledLessons();
    },
    methods: {
        getCancelledLessons() {
            window.axios.get("/lesson_cancelled").then((response) => {
                this.cancelledLessons = response.data;
            });
        },
    },
};
</script>

<style lang="scss">
.proHomeTasks {
    margin-top: 10px !important;
    margin-bottom: 20px;
}
.bottomTasks {
    .bagLink,
    .bagLink2 {
        padding: 0px !important;
        height: 124px;
        overflow: hidden;
    }
    .bagLink2 {
        background: #267962 !important;
    }
    a {
        padding-top: 20px !important;
        position: relative;
        padding-bottom: 30px;
        padding-left: 20px;
        display: block;
        height: 100%;
        .bag {
            top: auto !important;
            position: absolute;
            bottom: -5px;
            left: 2px;
        }
        .prof {
            top: auto !important;
            position: absolute;
            bottom: 20px;
            left: 20px;
        }
        .arrow {
            position: absolute;
            right: 20px !important;
            top: auto !important;
            bottom: 20px !important;
        }
    }
}
</style>
